export default __webpack_public_path__ + "static/media/CoinTwoKahshCard.9a6307e5.png";